import { SET_PERMISSIONS  } from "../actions/types";

const initialState = {};

function initPermissions(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_PERMISSIONS:
      return { ...payload };
    default:
      return state;
  }
}

export default initPermissions;
